module.exports = __webpack_public_path__ + "media/apps/hero-mobile-gif-caaf2ed1.jpg";